import angular from 'angular';

export type EcTheme = 'app-legacy' | 'app-next' | 'admin-legacy' | 'admin-next';

const STORAGE_KEY = 'ec-theme';
const ATTR = 'data-ec-theme';
const DEFAULT_THEME: EcTheme = 'app-legacy';

export class EcThemeService {
  static $inject: string[] = [];

  private _current: EcTheme;

  constructor() {
    const stored = localStorage.getItem(STORAGE_KEY) as EcTheme | null;
    this._current = stored ?? DEFAULT_THEME;
    this._apply(this._current);
  }

  set(theme: EcTheme): void {
    this._current = theme;
    localStorage.setItem(STORAGE_KEY, theme);
    this._apply(theme);
  }

  get(): EcTheme {
    return this._current;
  }

  private _apply(theme: EcTheme): void {
    document.documentElement.setAttribute(ATTR, theme);
  }
}

export const EC_THEME_MODULE = 'ec.theme';

angular
  .module(EC_THEME_MODULE, [])
  .service('ecThemeService', EcThemeService);
